import type { BlockComponent } from '@akademi/site-builder-runtime';
import { RestaurantHero } from './RestaurantHero';
import { OpeningHours } from './OpeningHours';
import { RestaurantMenu } from './RestaurantMenu';
import { RestaurantOrder } from './RestaurantOrder';
import { RestaurantBooking } from './RestaurantBooking';

/**
 * The restaurant vocabulary an operator can drop onto a page.
 *
 * <p>A restaurant tenant is not a second app. It is a storefront tenant whose
 * channel answers `GET /v1/public/storefront/hospitality/site?domain=` and
 * whose operator has placed these five blocks on pages they authored — same
 * host, same proxy, same shell, same `[locale]/[...slug]` pipeline. There is no
 * `commerce/frontends/restaurant`, no port 3070 and no restaurant middleware;
 * see `docs/plan/phase-11-stack-change.md` §3.
 *
 * <p>They live in this app rather than in `@akademi/site-builder-blocks`
 * because they read a source that is not in the shared runtime yet (see
 * `lib/hospitality/hospitalitySource.tsx`). Moving both upstream together is
 * the follow-up; splitting them would leave a shared block reading a host's
 * private context.
 */
export const hospitalityBlocks: Record<string, BlockComponent> = {
  RestaurantHero: RestaurantHero as BlockComponent,
  OpeningHours: OpeningHours as BlockComponent,
  RestaurantMenu: RestaurantMenu as BlockComponent,
  RestaurantOrder: RestaurantOrder as BlockComponent,
  RestaurantBooking: RestaurantBooking as BlockComponent,
};

export { RestaurantHero, OpeningHours, RestaurantMenu, RestaurantOrder, RestaurantBooking };
